module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image-chap"
  }, [_c('a', {
    attrs: {
      "id": "ch02"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "70",
      "src": "images/common.jpg",
      "width": "85"
    }
  }), _vm._v(" Chapter 2")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Have you ever thought that if one thing hadn’t happened, a whole set of things never would have either? Like dominoes in time, a single event kicked off an unstoppable series of changes that gained momentum and spun out of control, and nothing was ever the same again. Don’t ever doubt that a mere second can change your life forever.")]), _vm._v(" "), _c('p', {
    staticClass: "secbreak"
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "height": "27",
      "src": "images/common2.jpg",
      "width": "30"
    }
  })])]), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("On a Friday about a month and a half before school was out for the summer, my mom left work early to buy groceries before picking my brother and me up at the after-school program we both went to. She never liked shopping with us, and avoided it whenever she could, because she said it took twice as much time and three times as much money. If I hadn’t pestered her for homemade pizza, if she hadn’t said, “Hey, why not, it’s Friday,” she never would have gone to the supermarket to buy a crust mix, pizza sauce, ")]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("pepperoni, and lots and lots of mozzarella cheese, never would have pulled out onto the highway when the light turned green, only to be hit in the driver’s side by some guy who was too important to stop for a common red light. A couple of seconds one way and she would have come home grumbling about how this idiot had come from nowhere and forced her to slam on her brakes, a few seconds the other way and he would have been long gone before she stepped on the gas. Or maybe he would have crashed into some other poor kid’s mom. For want of a pepperoni pizza, my life, as I knew it then, was lost.")])]), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("At first it was cool when all the other kids started leaving before us. Often we were the first to be picked up, which was fine at the beginning of the year, because I didn’t know anyone really, and I was one of the oldest kids there, on top of it. But since January, Elizabeth from my class at school had started coming three days a week, and we’d started to be friends, although she hadn’t paid any attention to me before that. Actually, not many kids had paid much attention to me. The good kind of attention anyway. Elizabeth even introduced me to her best friend, Rachel, and the three of us had started hanging ")]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("out, going to a movie now and then, or going to the mall, like real buddies.")])]), _c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("When we first moved last year, I hated my new school so much that I told my mom I wasn’t going anymore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to finish school so you can go to a good college,” Mom said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if I don’t want to go to college at all?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have to go to college so you can get a good job and support yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Maybe I’ll just let my husband support me.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mom raised her eyebrow at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“If that’s what you decide after you have a good education and a good job, fine, but you will learn to support yourself.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I want to be homeschooled!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Silly! I can’t homeschool you, because I went to a good college and have a good job so I can support us.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Elizabeth’s mother picked her up first, and then the other kids starting clearing out. Pretty soon Free and I had the computers all to ourselves without the usual time limits. We both got involved in what we were doing and didn’t really notice we were the only ones left, until some lights started flicking off. Shirley ")]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("was watching us, and she made an attempt to be cheery, but you could tell she was getting annoyed.")])]), _c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Guess your mom had a meeting that went a little long, huh, guys?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free and I looked at each other. Mom was never late. We knew that. Shirley knew that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We both went back to our games, but I could tell that Free wasn’t really into it anymore, and neither was I. It was still light out, but you could tell the sun was starting to angle low.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shirley left the room and I could see her pacing out in the hall, looking at her watch, cell phone at her ear. When she came back, she said, “Does your dad live close by?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” I said. Maybe he did. I didn’t know.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Grandparents?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t have any.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shirley sighed, then walked out of the room again. I could hear her shoes clicking in the hallway as she paced with her phone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, guys, fifteen more minutes and then we’re leaving. I’ve got a class tonight, and I can’t hang around any longer.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where are we going?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("“Your mom listed your neighbor Penny as a contact. She’ll meet us at your house.”")])]), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Both of us had stopped playing on the computer.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“What if our mom shows up after we leave?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll leave a note for her.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen minutes went by and Mom didn’t come. Shirley took us home, nobody saying anything. Of course, Free never does anyway. Penny was sitting on the porch step with our house key, and there was a sound like far-off thunder from inside the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Babe is a little upset,” Penny said. “He knows I’m out here, but there was no way I was going in without you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He wouldn’t hurt you,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I wasn’t concerned about him "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("hurting")]), _vm._v(" me.” Penny stood up and opened the door. Shirley’s face did this classic horror movie expression—eyebrows up, mouth in an "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("O")]), _vm._v("—as she braced herself on the railing.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("Babe knew enough not to blast through the doorway, but he did everything except that. Babe is a major beast, black and a hundred and fifty pounds, at least half of which my mom says is drool. Babe is a ")]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("Newfoundland, and sweet as syrup, but a little intense. We were late, and he knew it. He slimed us all as we entered, including Shirley, who was still a little in shock. She looked at the wide wet stripe Babe had laid up the side of her nice black pants. She went to rub it off, thought better of it, and stood there with her hands in the air.")])]), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“It sparkles when it dries,” I said. I was trying to be helpful. Really.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free grabbed Babe by the collar and tugged him away from Shirley. Of course, he couldn’t have done it if Babe hadn’t wanted to cooperate, but Babe generally tries to accommodate you once he gets the drift of what you want. Shirley left, still shooting glances at the viscous goo on her pants.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Penny lived alone next door, her husband dead, her kids grown and gone. She and my mom had struck up an odd friendship: Single Career Supermom meets Old-Fashioned Housewife. But like my mom says, if it ain’t broke, don’t fix it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” Penny said, with one of those looks of fake good cheer. I don’t know who adults think they’re fooling. “I’m sure your mom will be home soon. Probably a flat tire or something.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("No way, Free and I both knew that. Mom hated cell phones, but flat tires were one of the reasons she carried one. If she wasn’t answering her cell phone, there was a reason.")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Do you have any homework to do while I make something for you to eat?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We shook our heads.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” she said, smile too wide. “I’ll just see what I can find to feed you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were eating turkey sandwiches when there was a knock on the door. Free and I looked at each other and we knew. Penny took a little longer to catch on, but she toppled onto it as well when she opened the door and saw a guy in a uniform standing there. Blue uniform. Shiny badge. Crisp billed hat, which he took off when she answered the door.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, no,” Penny said, then put her hand to her mouth. She stepped outside and shut the door behind her. I opened it again. The cop stopped in midsentence when he saw me—“emergency room” was all we heard. Free grabbed my hand and I held on tight. Penny turned to us, and we could see that her eyes were already that funny watery red that adults’ eyes go when they try not to cry.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("“Excuse me,” she said, and walked into the house. I felt bad for the guy as he watched her leave. He took a deep breath and said one word: “Your-mom’s-been-in-an-accident-but-she’s-going-to-be-okay.”")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("‘Okay.’ What precisely does that mean?")]), _vm._v(" I wondered. People were always saying things were going to be okay, but they never said when. Penny was crying because my mom was going to be okay? I didn’t think so.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Take us to her,” I said. Free crowded in closer to me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She can’t see you right now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t care if she can see us. We want to see her.” Was she blind? I wondered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Penny came up behind us, blowing her nose.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry,” she said. “I just needed a minute.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We want to see our mom,” I said again, and Penny’s and the policeman’s eyes met above us. I hate it when adults do that.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The cop squatted down so he was at Free’s eye level. I hate it when adults do that, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She’s in surgery. She may be there for a while.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I don’t care,” I said, in what Mom calls my princess-wants-it-now voice.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Penny looked at the policeman. He looked at her.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("“I’ll call the hospital and find out when we can see her,” she said.")])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Free and I looked at Penny.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why don’t I go do that right now,” she said, and walked back into the house.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The policeman put his hat on and left, his relief apparent.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free and I sat on the step and watched the cop car drive off. I guess neither of us wanted to hear only Penny’s end of the conversation with the hospital, for fear of what she might say.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After a while we heard steps from inside the house. The door opened.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well,” Penny said in an everything’s-going-to-be-just-fine voice, “she’s still in surgery, but they will call us when she gets out. They said she won’t come out of the recovery room until late tonight, and they suggested we come first thing in the morning. I’m sure that’s what your mother would want. Okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That “Okay?” got to me. Mom always says that no one, particularly adults speaking to children, should ever end a thought with “okay?” unless they really were asking for permission. Well, Penny wasn’t getting my permission.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Free’s lip started to quiver, but I squeezed his hand and just nodded at Penny. We sat at the table in front of our turkey sandwiches, none of us talking, none of us eating.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“I guess I’ll go do some homework,” I said to Penny. She nodded, not remembering I’d already told her I didn’t have any. I knew she wanted to do something for us but didn’t know what it could possibly be. Sometimes you just have to do things for yourself.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When Penny looked away, I beckoned for Free. He followed me, and I pulled him into my room.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How much money do you have?” I whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Without a fuss he got his bank, and we pooled our savings. I looked up taxis in the yellow pages and chose On-the-Double because I liked the name. I called and, using my best grown-up voice, inquired what the fare to the city hospital was, then asked to be picked up immediately. Free and I climbed out my window, glad that Babe was in the house instead of in the backyard, because he never would have let us sneak off. We walked a few houses down to the address I’d given On-the-Double, and when the taxi pulled up, we climbed in the back. The driver turned around and looked at us.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("“Are we waiting for your mom or for your dad?”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Neither,” I said. “Our mother’s been in a car accident, and we need to get to the hospital. We have enough money. I made sure before I called,” I added, looking earnest and honest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wished he would get a move on. If Penny came out of the house, it was all over.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Please hurry,” I said, and I was surprised that my voice shook, even though I was acting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Anybody know you’re going?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, the neighbor, but she couldn’t, um, accompany us. The hospital is expecting us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At that, the taxi driver pulled away from the curb. He said nothing all the way to the hospital, but he kept glancing in his rearview mirror at us. When he let us out, I counted the exact fare out into his hand, mostly quarters and dimes, and Free and I ran into the hospital.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We followed the signs to the information desk, and I announced that we were there to see Annalise LaMer. A nurse, whose name tag said "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("INGRID")]), _vm._v(", glanced at me and then at Free.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Is there an adult with you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" our adult.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Ingrid typed something into the computer. Then she summoned another nurse and they put their heads together, whispering. Ingrid made a phone call that I couldn’t quite hear, but soon some guy in those weird green baggy hospital clothes came through the double doors and went over to the nurses. They gestured toward Free and me, then the three of them turned to huddle with their backs to us. The man finally walked toward us.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hey, guys, how’s it going?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I wanted to tell him not to bother with the buddy act, but I gave him my company best manners instead. Mom says you can think whatever you wish, but it’s what you say and how you say it that will determine whether or not you get what you want.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re here to see our mother.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Dr. Racine. I saw your mom in the emergency room.” My mother hates it when people introduce themselves with a title. “ ‘Doctor’ is a funny first name, don’t you think?” she’d say. This probably wasn’t the time to bring that up, though.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about if we get you guys a snack and—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We just want to see our mother, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Who brought you here?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“A taxi.” Although that was a what, not a who.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Where’s your dad?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“He’s not around.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He squinted at me.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“At all,” I said. This guy was a little slow for a doctor, I thought. Why are people so obsessed with someone who doesn’t matter?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How old are you?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Why?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There’s a minimum age for the recovery room.” He did his best to look sorry. I switched to my more assertive mode, the way I’d seen my mother do a number of times.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We need to see our mother. Just for a few minutes, but we do need to see her. And we’re not leaving until we do.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He exhaled a little. “Children aren’t really allowed in the recovery room.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What did he mean by “really”? Were children “sort of” allowed in the recovery room?")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("“That’s not a very kid-friendly policy,” I said, then remembered my strategy and tried another tack. “Please. We haven’t seen her since this morning. She didn’t pick us up after school, and we didn’t know ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("anything until a cop came and told us what happened. We came here as soon as we could. To. See. Our. Mom.”")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Racine guy smiled. I didn’t see anything to smile about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“After surgery your mom will be very sleepy. She’ll be hooked up to some tubes and won’t be able to talk to you. I know for a fact that she’s pretty bruised up. She wouldn’t want you to see her that way, would she now? She wouldn’t want you to be frightened.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re already frightened.” Duh.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Racine guy stopped smiling. Ingrid came over with some donuts and soda for us. That was not a good sign—I have never seen a nurse sugar kids up. She whispered something to the Racine guy, then gave him a look that must have meant something to him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay,” he said, after looking at his watch. “You win. After they move your mom to the recovery room, you can see her for five minutes. Five minutes. Only.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free and I nodded.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’ll come get you then,” he said.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Ingrid gave Free and me each some crayons and a coloring book, and we sat in the waiting room for ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("what seemed like a few days, not even pretending to color. We pretended to watch TV, pretended to look at magazines, and I pretended that I was not more terrified than I had ever been before in my life. It was solid black outside when the Racine guy came and got us. We followed him down a confusing series of halls, turning one way and then another, until we entered a room that was basically dark, with a few small, really bright lights.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“You can’t touch her, okay?” There it was again: "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Okay?")]), _vm._v(" “Five minutes, and then you have to leave.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Free’s fingernails dug into my hand so hard I almost pulled it away from him, but it was good to have something to focus on.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The air bag broke her nose,” the Racine guy said, “so she has black eyes. Her left arm, collarbone, and a couple of ribs are broken as well.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That didn’t sound too terrible. “Is she going to be okay?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He paused. “Her hip bone was pretty cracked up, as well as her thigh and left knee. It all had to be pinned and screwed together.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("I thought of the screwdriver Mom had used to put up our basketball hoop. I thought of safety pins. ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("I thought doctors were supposed to use sophisticated implements, not carpenter’s tools.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At first I didn’t recognize the woman lying on the table. Her face was a mess, all swollen and bruised. My mom never stopped moving, but this person was very, very still. It was my mom’s hair, though. Long and thick like mine. Light brown, a little wavy. A few strands of gray.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A nurse was by Mom’s side, adjusting some tube. She looked up at us, and then glanced at the doctor.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Her children,” the Racine guy said. He seemed to be apologizing. “I told them only five minutes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She may look bad, but she’s not in any pain,” the nurse said. “She’s going to be okay, but your mom is going to have a long road ahead of her. You’re going to have to help her get better, all right?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I reached out and squeezed Mom’s hand when the nurse turned her back. Mom told me once that some rules are made to be broken. The Racine guy started to say something, then stopped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Everything’s going to be fine, Mom,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She can’t hear you, sweetie,” the nurse said, her back still to us.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("“Yes, she can,” I said, for Mom had squeezed my hand back. A single tear ran down the side of her face and Free reached up to wipe it. Then he put his hand over both of ours, and I swear my mom smiled.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Right now she needs all her energy to get better,” the Racine guy said. “You can come back in the morning and see her again.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When we got back to the waiting room, the taxi man was there. So was Penny. I could see she was torn between feeling bad for us and bawling us out.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The taxi man stepped forward.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sorry, guys,” he said. “It just didn’t feel quite right. After I got off work, I went back to where I picked you up and started knocking on doors. This woman was beside herself looking for you. She even called the cops.” Penny looked at us and took a deep breath, in preparation for some sort of lecture.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Thank you,” I said to him, and then to Penny before she could say anything, “We’re ready to go now.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Actually, I was glad they were there. I hadn’t thought about getting back home, and we didn’t have enough money for another taxi.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("The taxi guy looked at us, then gave both Penny and me his card.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Call me if I can help,” he said. Then he handed back the pile of change I had given him. “No charge for emergencies,” he said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c60927b0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch02.vue
// module id = 69
// module chunks = 0